export default function TableLoad() {
  return (
    <>
      <div className="table-table-responsive scrollbar mx-n1 px-1">
        <table className="table fs-9 mb-0">
          <thead>
            <tr>
              <th scope="col">
                 
              </th>
              <th scope="col">
                
              </th>
              <th scope="col">
                
              </th>
              <th scope="col">
                
              </th>
              <th scope="col">
                
              </th>
              <th scope="col">
                
              </th>
            </tr>
          </thead>
          <tbody className="list">
            <tr className="hover-actions-trigger btn-reveal-trigger position-static">
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
            </tr>
            <tr className="hover-actions-trigger btn-reveal-trigger position-static">
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
            </tr>
            <tr className="hover-actions-trigger btn-reveal-trigger position-static">
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
            </tr>
            <tr className="hover-actions-trigger btn-reveal-trigger position-static">
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
            </tr>
            <tr className="hover-actions-trigger btn-reveal-trigger position-static">
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
            </tr>
            <tr className="hover-actions-trigger btn-reveal-trigger position-static">
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
              <td>
                <p className="placeholder-glow">
                  <span className="placeholder col-12 rounded"></span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
